import Icon from '../components/Icon.vue'

Icon.register({"venus":{"width":288,"height":512,"paths":[{"d":"M288 176C288 96.5 223.5 32 144 32S0 96.5 0 176C0 244.5 47.9 301.9 112 316.4V368H76C69.4 368 64 373.4 64 380V420C64 426.6 69.4 432 76 432H112V468C112 474.6 117.4 480 124 480H164C170.6 480 176 474.6 176 468V432H212C218.6 432 224 426.6 224 420V380C224 373.4 218.6 368 212 368H176V316.4C240.1 301.9 288 244.5 288 176zM64 176C64 131.9 99.9 96 144 96S224 131.9 224 176 188.1 256 144 256 64 220.1 64 176z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/venus.js
// module id = l9OD
// module chunks = 0